var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags_chart_container w50 left margin margin_r_hf margin_l_c"},[(_vm.mainView === 'tags_chart')?_c('tags-chart'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }